<div class="cd-popup" role="alert">
  <div class="cd-popup-container text-center">
    <p>{{dynamicDialogConfig.data.message}}</p>
    <div class="cd-buttons">
      <button class="btn btn--primary mr-2" (click)="onYes()">OK</button>
    </div>
  </div>
</div>
